import {
    AUTHENTICATED,
    AUTHENTICATION_ERROR,
    UNAUTHENTICATED,
    UPDATE_EMAIL_SETTING_SUCCESS,
    UPDATE_MANAGER_APPROVAL_SUCCESS,
} from '../actions/types';

const initialState = {
    userData: {}
}

export default (state=initialState, action) => {
    switch(action.type) {
        case AUTHENTICATED:
            return { ...state, authenticated: true, userData: action.payload };
        case UNAUTHENTICATED:
            return { ...state, authenticated: false, userData: {} };
        case AUTHENTICATION_ERROR:
            return { ...state, error: action.payload };
        case UPDATE_EMAIL_SETTING_SUCCESS:
            const userData = state.userData;
            return { ...state, userData: { ...userData, email: action.payload} };
        case UPDATE_MANAGER_APPROVAL_SUCCESS:
            const data = state.userData;
            return { ...state, userData: { ...data, manager_approval_settings: action.payload} };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducers.ts